'use client';

import { c as _c } from "react/compiler-runtime";
import { sendGTMEvent } from '@next/third-parties/google';
import analytics, { getDonationFormType } from 'product-analytics';
import { useEffect, useEffectEvent } from 'react';
import sanitize from 'sanitize-html';
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers';
import { usePaymentMethodsToRender } from '@/donationPages/_dependencies/NativePaymentMethods';
import type { PaymentMethods } from 'api-graphql-types';
function useTrackDonationFormVisit() {
  const $ = _c(13);
  const {
    receiverName,
    receiverId,
    receiverType,
    receiverGtmBrand: brand,
    channel,
    showCodonation
  } = useDonationFormConfig();
  const {
    paymentMethodsToRender,
    nativePaymentsLoading
  } = usePaymentMethodsToRender();
  let t0;
  if ($[0] !== brand || $[1] !== channel || $[2] !== paymentMethodsToRender || $[3] !== receiverId || $[4] !== receiverName || $[5] !== receiverType || $[6] !== showCodonation) {
    t0 = () => {
      sendGTMEvent({
        event: "eeCheckout",
        ecommerce: {
          currencyCode: "EUR",
          checkout: {
            actionField: {
              step: 1,
              option: "form loaded"
            },
            products: [{
              name: sanitize(receiverName),
              id: `${receiverType}#${receiverId}`,
              brand,
              quantity: 1
            }]
          }
        }
      });
      analytics.donationFormOpened({
        donation_form_type: getDonationFormType({
          receiverId,
          receiverType,
          channel,
          showCodonation
        }),
        receiver_type: receiverType,
        id: receiverId,
        available_payment_methods: paymentMethodsToRender as PaymentMethods[]
      });
    };
    $[0] = brand;
    $[1] = channel;
    $[2] = paymentMethodsToRender;
    $[3] = receiverId;
    $[4] = receiverName;
    $[5] = receiverType;
    $[6] = showCodonation;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const trackVisit = useEffectEvent(t0);
  let t1;
  if ($[8] !== nativePaymentsLoading || $[9] !== trackVisit) {
    t1 = () => {
      if (nativePaymentsLoading) {
        return;
      }
      trackVisit();
    };
    $[8] = nativePaymentsLoading;
    $[9] = trackVisit;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== nativePaymentsLoading) {
    t2 = [nativePaymentsLoading];
    $[11] = nativePaymentsLoading;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  useEffect(t1, t2);
}
export default useTrackDonationFormVisit;